import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800 text-gray-400 text-sm">
      {/* Upper Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        {/* Col 1: Firmainfo */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img
              src="https://assets.auxodev.dk/assets/48e1c649-5942-45fb-ad5e-8c057f6b1ff1/frejlev-auto-black-logo_1.png"
              alt="Frejlev Auto"
              className="h-14 w-auto"
            />
          </div>
          <div className="space-y-2 text-xs">
            <p className="font-semibold text-white">Frejlev Auto v/ Jacob Kvist</p>
            <p className="flex items-start gap-2">
              <i className="fa-solid fa-location-dot text-[#5cbe4f] mt-0.5"></i>
              <a 
                href="https://maps.app.goo.gl/NYxKMqLFdfv6L8976" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-white transition-colors"
              >
                Svenstrupvej 39, 9200 Aalborg SV
              </a>
            </p>
            <p className="flex items-center gap-2">
              <i className="fa-solid fa-phone text-[#5cbe4f]"></i>
              <a href="tel:+4530345096" className="hover:text-white transition-colors">30 34 50 96</a>
            </p>
            <p className="flex items-center gap-2">
              <i className="fa-solid fa-envelope text-[#5cbe4f]"></i>
              <a href="mailto:frejlevauto@gmail.com" className="hover:text-white transition-colors">frejlevauto@gmail.com</a>
            </p>
            <p className="text-gray-500 pt-1">CVR: 41949589</p>
            <p className="pt-1">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="inline-flex items-center gap-2 text-white hover:text-[#5cbe4f] transition-colors font-medium"
              >
                <i className="fa-brands fa-facebook text-[#5cbe4f] text-sm"></i>
                <span>Følg os på Facebook</span>
              </a>
            </p>
          </div>
        </div>

        {/* Col 2: Quicklinks */}
        <div className="space-y-4">
          <h4 className="text-white font-bold text-sm uppercase tracking-wider">Quicklinks</h4>
          <ul className="space-y-2 text-xs">
            <li>
              <Link to="/autovaerksted" className="hover:text-[#5cbe4f] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[9px] text-[#5cbe4f]"></i>
                <span>Autoværksted</span>
              </Link>
            </li>
            <li>
              <Link to="/daek-og-hjulskift" className="hover:text-[#5cbe4f] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[9px] text-[#5cbe4f]"></i>
                <span>Dækskifte</span>
              </Link>
            </li>
            <li>
              <Link to="/klargoering-til-syn" className="hover:text-[#5cbe4f] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[9px] text-[#5cbe4f]"></i>
                <span>Klargøring til syn</span>
              </Link>
            </li>
            <li>
              <Link to="/mekaniker" className="hover:text-[#5cbe4f] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[9px] text-[#5cbe4f]"></i>
                <span>Mekaniker</span>
              </Link>
            </li>
            <li>
              <Link to="/reparationer" className="hover:text-[#5cbe4f] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[9px] text-[#5cbe4f]"></i>
                <span>Reparationer</span>
              </Link>
            </li>
            <li>
              <Link to="/serviceeftersyn" className="hover:text-[#5cbe4f] transition-colors flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[9px] text-[#5cbe4f]"></i>
                <span>Service</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Col 3: Åbningstider */}
        <div className="space-y-4">
          <h4 className="text-white font-bold text-sm uppercase tracking-wider">Åbningstider</h4>
          <ul className="space-y-2 text-xs">
            <li className="flex justify-between border-b border-zinc-800 pb-1.5">
              <span className="text-gray-400">Mandag - Torsdag:</span>
              <span className="text-white font-medium">07.00 - 16.00</span>
            </li>
            <li className="flex justify-between border-b border-zinc-800 pb-1.5">
              <span className="text-gray-400">Fredag:</span>
              <span className="text-white font-medium">07.00 - 14.00</span>
            </li>
            <li className="flex justify-between pb-1.5">
              <span className="text-gray-400">Weekend:</span>
              <span className="text-[#5cbe4f] font-semibold">Lukket</span>
            </li>
          </ul>
        </div>

        {/* Col 4: Medlemskaber */}
        <div className="space-y-4">
          <h4 className="text-white font-bold text-sm uppercase tracking-wider">Medlem af DBR & FV</h4>
          <div className="space-y-3 text-xs">
            <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-3">
              <p className="text-white font-semibold mb-1">Dansk Bilbranche Råd</p>
              <p className="text-gray-400 leading-relaxed text-[11px]">
                Vi er medlem af Dansk Bilbranche Råd. Værkstedet er uafhængigt af bilmærker og servicerer alle modeller.
              </p>
            </div>
            <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-3">
              <p className="text-white font-semibold mb-1">Frie Danske Værksteder</p>
              <p className="text-gray-400 leading-relaxed text-[11px]">
                Værkstedet er et af de Frie Danske Værksteder – du bevarer altid fabriksgarantien på din bil.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="bg-black py-6 border-t border-zinc-800 text-xs">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-gray-500">
            <span>&copy; {currentYear} Frejlev Auto v/ Jacob Kvist</span>
            <span>CVR: 41949589</span>
          </div>
          <div className="flex gap-6 text-gray-400">
            <Link to="/frejlev-auto-dit-lokale-autovaerksted" className="hover:text-white transition-colors">Profil</Link>
            <Link to="/kontakt-frejlev-auto" className="hover:text-white transition-colors">Kontakt</Link>
            <Link to="/galleri" className="hover:text-white transition-colors">Galleri</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
